var map = {
	"./1.png": 64422,
	"./2.png": 5661,
	"./3.png": 84532,
	"./4.png": 30443,
	"./5.png": 9314,
	"./6.png": 57497,
	"./7.png": 76944,
	"./8.png": 27479,
	"./9.png": 84462
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55644;